import React, { ReactNode } from 'react'
import { Box } from '@mui/material'
import HeaderMenu from './HeaderMenu'
import { muahangKiotLike } from './muahangKiotTokens'

export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  CMTYEUCAUMUA = 'CMTYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',
}

interface BasicLayoutProps {
  children: ReactNode
}

/** Shell: header full bleed; content uses `kiotPageContentMarginXPx` horizontal gutter. */
const BasicLayout: React.FC<BasicLayoutProps> = ({ children }) => {
  const gutter = `${muahangKiotLike.kiotPageContentMarginXPx}px`

  return (
    <Box
      component="main"
      sx={{
        width: '100%',
        maxWidth: '100vw',
        height: '100vh',
        minHeight: '-webkit-fill-available',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        bgcolor: muahangKiotLike.pageCanvas,
      }}
    >
      <HeaderMenu />
      <Box
        component="div"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          px: gutter,
          py: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: muahangKiotLike.pageCanvas,
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default BasicLayout
